import React from "react";
import { FaLinkedin, FaInstagram, FaFacebookF } from "react-icons/fa";
import SubscribeForm from "./SubscribeForm";

const Footer = () => {
  return (
    <footer className="footer" style={{ backgroundColor: "#000000" }}>
      
      <div className="footer-blur"></div>

      <div className="footer-container">

        {/* Top/Left Section - Brand Column Layout containing Title & Contact Row */}
        <div className="footer-left">
          <div className="footer-brand-row">
            <h2 className="footer-heading">
              Helping <br />
              businesses <br />
              scale their <br /> e-commerce
            </h2>

            <div className="footer-contact-info">
              <p className="contact-email">info@softbecklearning.com</p>
              <p className="contact-phone">+92 415241874</p>
              <p className="contact-address">MGC Tower, 356-A Small D Ground Peoples Colony No. 1</p>
              <p className="contact-city">Faisalabad, Pakistan</p>
            </div>
          </div>

          <div className="footer-social">
            <a href="https://www.linkedin.com/company/softbeck-learning-hub-smc-pvt-ltd/posts/?feedView=all" className="social-icon" target="_blank" rel="noreferrer">
              <FaLinkedin />
            </a>

            <a href="https://www.instagram.com/softbecklearninghub/" className="social-icon" target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>

            <a href="https://www.facebook.com/softbecklearninghub" className="social-icon" target="_blank" rel="noreferrer">
              <FaFacebookF />
            </a>
          </div>
        </div>

        {/* Center Quick Links Stack */}
        <div className="footer-center">
          <h4 className="footer-title">Quick Links</h4>
          <div className="quick-links">
            <button><a href="/">Home</a></button>
            <button><a href="/about-us">About</a></button>
            <button><a href="/internships">Internships</a></button>
            <button><a href="/contact">Contact</a></button>
          </div>

          <br />

          <h4 className="footer-title">Our Services</h4>
          <div className="quick-links">
            <button><a href="/services/tiktok-shop">TikTok Shop</a></button>
            <button><a href="/services/shopify">Shopify</a></button>
            <button><a href="/services/ebay">eBay</a></button>
          </div>

          <br />

          <h4 className="footer-title">TikTok Shop</h4>
          <div className="quick-links">
            <button><a href="/services/tiktok-shop/account-creation">Account Creation</a></button>
            <button><a href="/services/tiktok-shop/account-handling">Account Handling</a></button>
            <button><a href="/services/tiktok-shop/account-scalability">Account Scalability</a></button>
            <button><a href="/services/tiktok-shop/account-hunting">Account Hunting</a></button>
            <button><a href="/services/tiktok-shop/account-listing">Account Listing</a></button>
            <button><a href="/services/tiktok-shop/order-processing">Order Processing</a></button>
            <button><a href="/services/tiktok-shop/order-tracking">Order Tracking</a></button>
          </div>

          <br />

          <h4 className="footer-title">Shopify</h4>
          <div className="quick-links">
            <button><a href="/services/shopify/account-creation">Account Creation</a></button>
            <button><a href="/services/shopify/account-handling">Account Handling</a></button>
            <button><a href="/services/shopify/account-scalability">Account Scalability</a></button>
            <button><a href="/services/shopify/account-hunting">Account Hunting</a></button>
            <button><a href="/services/shopify/account-listing">Account Listing</a></button>
            <button><a href="/services/shopify/order-processing">Order Processing</a></button>
            <button><a href="/services/shopify/order-tracking">Order Tracking</a></button>
          </div>

          <br />

          <h4 className="footer-title">eBay</h4>
          <div className="quick-links">
            <button><a href="/services/ebay/account-creation">Account Creation</a></button>
            <button><a href="/services/ebay/account-handling">Account Handling</a></button>
            <button><a href="/services/ebay/account-scalability">Account Scalability</a></button>
            <button><a href="/services/ebay/account-hunting">Account Hunting</a></button>
            <button><a href="/services/ebay/account-listing">Account Listing</a></button>
            <button><a href="/services/ebay/order-processing">Order Processing</a></button>
            <button><a href="/services/ebay/order-tracking">Order Tracking</a></button>
          </div>

          <br />
          <br />

          <h4 className="footer-title">Subscribe to our Newsletter</h4>
          <SubscribeForm />
        </div>
      </div>

      {/* Bottom Brand Layout */}
      <div className="footer-bottom">
        <div className="footer-huge-brand-text">
          <span className="brand-word-top">softbeck</span>
          <span className="brand-word-bottom">learning hub</span>
        </div>

        <div className="footer-meta-underlay">
          <div className="meta-left">
            <p className="footer-copyright">
              &copy; 2026 Softbeck Learning Hub. All rights reserved.
            </p>
          </div>

          <div className="meta-right">
            <div className="footer-links">
              <a href="/terms">Terms & Conditions</a>
              <a href="/privacy">Privacy Policy</a>
            </div>
          </div>
        </div>
      </div>

    </footer>
  );
};

export default Footer;